import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ 
  variant = 'default', 
  size = 'medium', 
  text = '', 
  showProgress = false, 
  progress = 0,
  className = ''
}) => {
  const renderSpinner = () => {
    switch (variant) {
      case 'pulse':
        return (
          <div className={`loading-pulse loading-${size}`}>
            <div className="pulse-dot"></div>
            <div className="pulse-dot"></div>
            <div className="pulse-dot"></div>
          </div>
        );
      
      case 'ripple':
        return (
          <div className={`loading-ripple loading-${size}`}>
            <div className="ripple-circle"></div>
            <div className="ripple-circle"></div>
            <div className="ripple-circle"></div>
          </div>
        );
      
      case 'bars':
        return (
          <div className={`loading-bars loading-${size}`}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        );
      
      case 'dots':
        return (
          <div className={`loading-dots loading-${size}`}>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        );
      
      case 'spinner':
        return (
          <div className={`loading-spinner loading-${size}`}>
            <div className="spinner-ring"></div>
          </div>
        );
      
      default:
        return (
          <div className={`loading-default loading-${size}`}>
            <div className="default-circle"></div>
          </div>
        );
    }
  };

  return (
    <div className={`loading-container ${className}`}>
      {renderSpinner()}
      
      {text && (
        <div className="loading-text">
          {text}
        </div>
      )}
      
      {showProgress && (
        <div className="loading-progress">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div className="progress-text">
            {Math.round(progress)}%
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
